import React, { useState, useEffect } from "react";
import { Tabs, Tab, Paper } from "@material-ui/core";
import { Club } from "api/clubs";
import { Membership } from "api/memberships";
import { ClubSelect, HelpscoutFab } from "components";
import AliasAccountsTab from "features/user/ProfileView/AliasAccountsTab";
import { UserProfile } from "api/user";
import i18n from "./i18n";
import ManageMembersTab from "./ManageMembersTab";
import NameChangesTab from "./NameChangesTab";
import RequestsTab from "./RequestsTab";
import ImportTab from "./ImportTab";

// prop types
interface MembersViewProps {
    club: Club | null,
    memberships: Membership[],
    userProfile: UserProfile | null,
}

// member-related admin stuff
const MembersView = ({ club, memberships, userProfile }: MembersViewProps) => {
    // ui state
    const [clubId, setClubId] = useState<string | undefined>();
    const [currentTab, setCurrentTab] = useState(0);
    const isCompany = club?.capabilities.includes("company");

    // reset ui
    useEffect(() => setClubId(club?.id), [club]);

    // render
    return (
        <>
            <HelpscoutFab club={club} />
            <Paper style={{ display: "flex", justifyContent: "space-between" }}>
                {/* tabs */}
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    value={currentTab}
                    onChange={(e, index) => setCurrentTab(index)}
                >
                    <Tab label={i18n.members} value={0} />
                    <Tab label={i18n.membershipRequests} value={1} />
                    <Tab label={i18n.nameChanges} value={2} />
                    <Tab label={i18n.import} value={3} />
                    {!userProfile?.isAlias && !isCompany && <Tab label={i18n.aliasAccounts} value={4} />}
                </Tabs>

                {/* club select */}
                <ClubSelect
                    clubId={clubId}
                    controlProps={{ style: { minWidth: "96px", marginRight: "8px" } }}
                    userRoles={["owner", "admin"]}
                    onChange={setClubId}
                />
            </Paper>
            {currentTab === 0 && <ManageMembersTab clubId={clubId} memberships={memberships} />}
            {currentTab === 1 && <RequestsTab clubId={clubId} />}
            {currentTab === 2 && <NameChangesTab clubId={clubId} />}
            {currentTab === 3 && <ImportTab clubId={clubId} />}
            {currentTab === 4 && !isCompany && <AliasAccountsTab clubId={clubId} userProfile={userProfile} fromAdminMenu />}
        </>
    );
};

export default MembersView;
